"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CardRenderer_1 = require("./CardRenderer");
exports.default = (function (_a) {
    var createElement = _a.createElement, getCardComponent = _a.getCardComponent;
    return function (_a) {
        var cards = _a.cards;
        return function (_a) {
            var index = _a[1];
            return CardRenderer_1.default({ createElement: createElement, getCardComponent: getCardComponent })(cards[index]);
        };
    };
});
